/* istanbul ignore file */
import { array as codecArray, number as codecNumber, oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { _SubmissionRubricItemDataParser } from './_SubmissionRubricItemDataParser';
const PatchRubricResultSubmissionDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    /* #__PURE__ */ parsers.object([
        ['items', /* #__PURE__ */ codecArray(codecNumber)],
    ]),
    /* #__PURE__ */ parsers.object([
        ['items', /* #__PURE__ */ codecArray(_SubmissionRubricItemDataParser)],
    ]),
]);
export const PatchRubricResultSubmissionData = PatchRubricResultSubmissionDataParser;
